import React from "react";
import { Logo, Colors } from '../../assets';
import { authWrapper, logoWrapper, authChildren, diffColorWrapper, authMainWrapper, diffColImg } from "./layout.module.css";

const AuthLayout = ({ children }) => {

  return (
    <div className={authWrapper}>
      <header className={logoWrapper}>
        <Logo />
      </header>

      <div className={authMainWrapper}>
        <div className={authChildren}>{children}</div>
        <div className={diffColorWrapper}>
          <Colors className={diffColImg} />
        </div>
      </div>
      
    </div>
  );
};
export { AuthLayout };